import {
  PRODUCT_TYPE_ROLLUP,
  PRODUCT_TYPE_INTEREST_SERVICE,
} from "lib/constants";

const productTypeResolver = (value) => {
  if (value === PRODUCT_TYPE_INTEREST_SERVICE) {
    return PRODUCT_TYPE_INTEREST_SERVICE;
  } else {
    return PRODUCT_TYPE_ROLLUP;
  }
};

export default productTypeResolver;
